import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.function.name";
import React from 'react';
import { getDoclet, joinElements } from './utils';

var isPrimitive = function isPrimitive(name) {
  return name[0].toLowerCase() === name[0];
};

var isArray = function isArray(t) {
  return t.name === 'Array';
};

var isComplex = function isComplex(t) {
  return ['signature', 'union', 'tuple', 'intersect'].includes(t.name);
};

function getType(type, tags, tokens) {
  var concrete = type;

  var get = function get(t) {
    return getType(t, tags, tokens);
  };

  var t = function t(token) {
    var _tokens$token;

    return (_tokens$token = tokens === null || tokens === void 0 ? void 0 : tokens[token]) !== null && _tokens$token !== void 0 ? _tokens$token : "pt-token pt-".concat(token);
  };

  function renderName(name) {
    return /*#__PURE__*/React.createElement("span", {
      className: t(isPrimitive(name) ? 'primitive' : 'name')
    }, name);
  }

  function renderNamedType(namedType) {
    return /*#__PURE__*/React.createElement("span", {
      className: t('type_signature')
    }, renderName(namedType.name), 'elements' in namedType && /*#__PURE__*/React.createElement(React.Fragment, null, '<', /*#__PURE__*/React.createElement("span", {
      className: t('elements')
    }, joinElements(namedType.elements, ', ', get)), '>'));
  }

  function renderArray(arrType) {
    return isComplex(arrType.elements[0]) ? renderNamedType(arrType) : /*#__PURE__*/React.createElement("span", {
      className: t('array')
    }, get(arrType.elements[0]), "[]");
  }

  var userType = getDoclet(tags, 'type');
  if (userType) return renderName(userType);

  switch (concrete.name) {
    case 'literal':
      return /*#__PURE__*/React.createElement("span", {
        className: t('literal')
      }, concrete.value);

    case 'signature':
      return /*#__PURE__*/React.createElement("span", {
        className: t("".concat(concrete.type, "-signature"))
      }, concrete.type === 'function' ? /*#__PURE__*/React.createElement(React.Fragment, null, "(", joinElements(concrete.signature.arguments, ', ', function (arg) {
        return /*#__PURE__*/React.createElement("span", {
          className: t('argument')
        }, arg.name, ": ", get(arg.type));
      }), ') => ', /*#__PURE__*/React.createElement("span", {
        className: t('return')
      }, get(concrete.signature["return"]))) : concrete.raw);

    case 'union':
      return /*#__PURE__*/React.createElement("span", {
        className: t('union')
      }, joinElements(concrete.elements, null, get));

    case 'tuple':
      {
        return /*#__PURE__*/React.createElement("span", {
          className: t('tuple')
        }, "[", joinElements(concrete.elements, ', ', get), "]");
      }

    case 'intersect':
      return /*#__PURE__*/React.createElement("span", {
        className: t('intersect')
      }, joinElements(concrete.elements, null, get));

    default:
      if (isArray(type)) return renderArray(type);
      if (isPrimitive(type.name)) renderName(type.name);
      return renderNamedType(type);
  }
}

function TypescriptTypeValue(_ref) {
  var type = _ref.type,
      tags = _ref.tags,
      tokens = _ref.tokens;
  return /*#__PURE__*/React.createElement(React.Fragment, null, getType(type, tags, tokens));
}

export default TypescriptTypeValue;